import { ArrayOf } from '../../../utils'
import {
    StepDistribution,
    AppState,
    Bins,
    BinState,
    PaginatedState,
    BinRefs,
    UIState,
} from './types'
import { getStatements } from '../../../i18n/Statements'
import { parseScreenParam } from './utils'
import { defaultParamsFitme, defaultQSortV2Params } from '../../../parameters/defaultParamsFitme'
import { QSortV2Params } from '../../../parameters/types'

const DeckSize = {
    d42: 42, // 3x power
    d39: 39, // 3x no-power
    d28: 28, // 2x power
    d26: 26, // 2x no-power
} as const
type DeckSizeEnum = keyof typeof DeckSize
export type DeckSizeType = (typeof DeckSize)[DeckSizeEnum]

export const stepDistributions42: ArrayOf<StepDistribution, 4> = [
    [11, 20, 11],
    [2, 4, 5],
    [5, 4, 2],
    [6, 8, 6],
]

export const maxBucketCapacities = {
    7: [2, 4, 5, 0, 20, 0, 5, 4, 2],
    9: [2, 4, 5, 6, 8, 6, 5, 4, 2],
}

export const stepDistribution: Record<
    DeckSizeType,
    ArrayOf<StepDistribution, 4>
> = {
    42: stepDistributions42,
    // TODO stepDistributionsXX
    39: stepDistributions42,
    26: stepDistributions42,
    28: stepDistributions42,
}

const defaultScreenParams = parseScreenParam(
    defaultParamsFitme.assessmentParams['stmsPerScreen']
)

const defaultUIState: Omit<UIState, 'updateWarningProps' | 'closeYesNoModal' | 'setHasNextBtn' | 'setFinalBucketsRnd'> = {
    hasNextBtn: false,
    warningProps: null,
    title: '',
    yesNoModalProps: null,
    histogramCount: [],
}

// FIXME Omit instead of using Pick
export const initialBinStore: Pick<
    AppState,
    | 'status'
    | 'rankedStms'
    | 'nStm'
    | 'nBucket'
    | 'stms2rank'
    | 'rankingIsReflected'
    | 'hasMidBucketRanking'
    | 'finalBuckets'
    | 'selectedBucket'
    | 'highlightedBars'
> &
    Pick<PaginatedState, 'page' | 'maxPerPage'> &
    Pick<BinState, 'selectedBinRef'> &
    Omit<UIState, 'updateWarningProps' | 'closeYesNoModal' | 'setHasNextBtn' | 'setFinalBucketsRnd'> &
    QSortV2Params
    = {
    page: 0,
    maxPerPage: defaultScreenParams.nStm,
    status: 'S1_42',
    rankedStms: [null, null, null, null],
    nStm: 42 as DeckSizeType,
    stms2rank: getStatements(),
    rankingIsReflected: true,
    hasMidBucketRanking: undefined,
    selectedBinRef: 'to_assign' as BinRefs,
    // FIXME 
    finalBuckets: [],
    selectedBucket: null,
    highlightedBars: [],
    ...defaultUIState,
    ...defaultQSortV2Params,
}